// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uTdCt","card_header":"Card_card_header__1ab3O","title":"Card_title__oLNNW"};